import React, { ComponentProps } from 'react';
import { ProgressBreadcrumb } from './ProgressBreadcrumb';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;

export enum ProgressBreadcrumbListTheme {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
}

export const ProgressBreadcrumbList: React.FC<{
    id: string;
    crumbs: ProgressBreadcrumbProps[];
    theme: ProgressBreadcrumbListTheme;
    activeCrumbNumber: number;
    orientation?: 'horizontal' | 'vertical';
    width?: string;
    height?: string;
}> = ({ id, crumbs, theme, activeCrumbNumber, orientation = 'vertical', width = 'auto', height = 'auto' }) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
        '--crumbCount': `${crumbs.length}`,
    };

    return (
        <>
            <div
                id={`progressBreadcrumbList_${id}`}
                className={`progressBreadcrumbList ${orientation}`}
                style={setStyle}
            >
                {crumbs?.map((crumb) => (
                    <ProgressBreadcrumb
                        id={crumb.id}
                        number={crumb.number}
                        currentNumber={activeCrumbNumber}
                        hasProgressed={activeCrumbNumber >= crumb.number}
                        handleClick={crumb.handleClick}
                        enabled={crumb.enabled}
                        theme={theme}
                    >
                        {crumb.children}
                    </ProgressBreadcrumb>
                ))}
            </div>
        </>
    );
};
